import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-452809d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h1", null, "PT管理宝")
], -1))
const _hoisted_2 = { style: {"margin-right":"12px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "FooterToolbar", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"8px"} }, "SplitMenus:", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Page Loading")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Light")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Dark")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Side")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Top")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Mix")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeartOutlined = _resolveComponent("HeartOutlined")!
  const _component_SmileOutlined = _resolveComponent("SmileOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_FooterToolbar = _resolveComponent("FooterToolbar")!
  const _component_pro_layout = _resolveComponent("pro-layout")!

  return (_openBlock(), _createBlock(_component_pro_layout, _mergeProps({
    collapsed: _ctx.baseState.collapsed,
    "onUpdate:collapsed": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.baseState.collapsed) = $event)),
    selectedKeys: _ctx.baseState.selectedKeys,
    "onUpdate:selectedKeys": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.baseState.selectedKeys) = $event)),
    openKeys: _ctx.baseState.openKeys,
    "onUpdate:openKeys": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.baseState.openKeys) = $event))
  }, _ctx.state, {
    loading: _ctx.loading,
    breadcrumb: { routes: _ctx.breadcrumb },
    "iconfont-url": "//at.alicdn.com/t/font_2804900_nzigh7z84gc.js"
  }), {
    menuHeaderRender: _withCtx(() => [
      _hoisted_1
    ]),
    collapsedButtonRender: _withCtx((collapsed) => [
      collapsed
        ? (_openBlock(), _createBlock(_component_HeartOutlined, { key: 0 }))
        : (_openBlock(), _createBlock(_component_SmileOutlined, { key: 1 }))
    ]),
    rightContentRender: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "logout",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoutHandle && _ctx.logoutHandle(...args)))
        }, "退出登录")
      ])
    ]),
    breadcrumbRender: _withCtx(({ route, params, routes }) => [
      (routes.indexOf(route) === routes.length - 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(route.breadcrumbName), 1))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { path: route.path, params }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(route.breadcrumbName), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
    ]),
    menuExtraRender: _withCtx(({ collapsed }) => [
      (!collapsed)
        ? (_openBlock(), _createBlock(_component_a_input_search, {
            key: 0,
            onSearch: _ctx.handleSearch
          }, null, 8, ["onSearch"]))
        : _createCommentVNode("", true)
    ]),
    menuFooterRender: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(_component_FooterToolbar, { key: 0 }, {
            extra: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    disabled: _ctx.state.layout !== 'mix'
                  }, [
                    _hoisted_6,
                    _createVNode(_component_a_switch, {
                      checked: _ctx.state.splitMenus,
                      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.splitMenus) = $event)),
                      disabled: _ctx.state.layout !== 'mix',
                      "checked-children": "ON",
                      "un-checked-children": "OFF"
                    }, null, 8, ["checked", "disabled"])
                  ], 8, _hoisted_5),
                  _createVNode(_component_a_button, { onClick: _ctx.handlePageLoadingClick }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_select, {
                    value: _ctx.state.navTheme,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.navTheme) = $event)),
                    style: {"width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "light" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "dark" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_a_select, {
                    value: _ctx.state.layout,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.layout) = $event)),
                    style: {"width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "side" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "top" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "mix" }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["collapsed", "selectedKeys", "openKeys", "loading", "breadcrumb"]))
}